import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
import { putEntities } from '../entities/actions';
import { deviationSchema } from '../normalizr/schemas/deviation';
import { normalize } from 'normalizr';
export var editDeviation = createAction(actionTypePrefix + ".EDIT_DEVIATION");
export var editDeviationSuccess = createAction(actionTypePrefix + ".EDIT_DEVIATION_SUCCESS");
export var deleteDeviation = createAction(actionTypePrefix + ".DELETE_DEVIATION");
export var deleteDeviationSuccess = createAction(actionTypePrefix + ".DELETE_DEVIATION_SUCCESS");
export var updateDeviationEntity = function (deviation) {
    var entities = normalize(deviation, deviationSchema).entities;
    return putEntities(entities);
};
export var updateNormalizedDeviationEntity = function (normalizedDeviation) {
    var _a, _b;
    return putEntities({
        entities: (_a = {},
            _a[deviationSchema.key] = (_b = {},
                _b[normalizedDeviation.entityId] = normalizedDeviation,
                _b),
            _a),
    });
};
//# sourceMappingURL=actionCreators.js.map